import classNames from 'classnames';
import {
  Button,
  FlexContainer,
  PartialWidthContainer,
  PropertyBlock,
  Tabs,
  Icon,
} from 'components';
import { observer } from 'mobx-react-lite';
import { Outlet, useNavigate } from 'react-router-dom';
import { useProperty, useTenancy } from 'state';
import styles from './TenancyViewScreenLayout.module.scss';

const tabsOptions = [
  {
    key: 'details',
    path: 'details',
    value: 'Details',
  },
  {
    key: 'payments',
    path: 'payments',
    value: 'Payments',
  },
  {
    key: 'notices',
    path: 'notices',
    value: 'Notices',
  },
];

/**
 * TenancyViewScreenLayout
 *
 * @return {JSX.Element}
 */
const TenancyViewScreenLayout = ({ className, children }) => {
  const navigate = useNavigate();
  const propertyDoc = useProperty();
  const tenancyDoc = useTenancy();

  const handleBack = () => {
    navigate(`../../main/tenancies`, { replace: true });
  };

  return (
    <PartialWidthContainer
      className={classNames(
        styles.TenancyViewScreenLayout,
        className,
        TenancyViewScreenLayout.displayName
      )}
      column
      small
      gap
    >
      <FlexContainer>
        <Button onClick={handleBack}>
          <Icon s name="goback" /> Back
        </Button>
      </FlexContainer>
      <FlexContainer column>
        {/*<View className={styles.PropertyTitle}>*/}
        {/*  <Txt caption>*/}
        {/*    {tenancyStatusMap[tenancyState.state.tenancyStatus]}*/}
        {/*  </Txt>*/}
        {/*</View>*/}
        <PropertyBlock
          imageUrls={propertyDoc.data.imageUrls}
          bathroomCount={propertyDoc.data.bathroomCount}
          bedroomCount={propertyDoc.data.bedroomCount}
          deposit={tenancyDoc.data.payments.rentAmount}
          tenants={tenancyDoc.data.tenantCount}
          postcode={propertyDoc.data.address.line1.toUpperCase()}
          className={styles.PropertyBlock}
        />
        <Tabs className={styles.Tabs} asNav options={tabsOptions} />
      </FlexContainer>
      <FlexContainer className={styles.Body} column>
        <Outlet />
      </FlexContainer>
    </PartialWidthContainer>
  );
};

TenancyViewScreenLayout.displayName = 'TenancyViewScreenLayout';

export default observer(TenancyViewScreenLayout);
